import React from 'react';
import { Sparkles } from 'lucide-react';

const MarqueeServices = () => {
  const currentServices = [
    'Social Media Marketing',
    'Influencer Selection',
    'Influencer Communication',
    'Briefing, Revisions and Publishing',
    'Contract and Payment Processes',
    'Campaign Management',
    'Communication and Content Strategies',
    'Content Production & Production',
  ];

  const marqueeStyles = {
    willChange: 'transform',
    backfaceVisibility: 'hidden',
    WebkitBackfaceVisibility: 'hidden',
    perspective: 1000,
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
  };

  return (
    <div className="bg-[#FFDD59] border-t-4 border-b-4 border-black">
      {/* First Marquee Row - Right to Left (visible on both mobile and desktop) */}
      <div className="py-3 md:py-4 overflow-hidden">
        <div 
          className="flex animate-marquee-smooth whitespace-nowrap"
          style={marqueeStyles}
        >
          {/* First set */}
          {currentServices.map((service, index) => (
            <div 
              key={`1-${index}`} 
              className="flex items-center mx-4 md:mx-8 flex-shrink-0"
            >
              <Sparkles size={18} className="text-black mr-2 md:mr-4 flex-shrink-0" fill="black" />
              <span className="text-sm md:text-xl font-bold text-black whitespace-nowrap">{service}</span>
            </div>
          ))}
          {/* Second set - duplicate for seamless infinite scroll */}
          {currentServices.map((service, index) => (
            <div 
              key={`2-${index}`} 
              className="flex items-center mx-4 md:mx-8 flex-shrink-0"
            >
              <Sparkles size={18} className="text-black mr-2 md:mr-4 flex-shrink-0" fill="black" />
              <span className="text-sm md:text-xl font-bold text-black whitespace-nowrap">{service}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Second Marquee Row - Left to Right (ONLY visible on mobile) */}
      <div className="md:hidden border-t-2 border-black py-3 overflow-hidden">
        <div 
          className="flex animate-marquee-reverse whitespace-nowrap"
          style={marqueeStyles}
        >
          {/* First set */}
          {currentServices.map((service, index) => (
            <div 
              key={`3-${index}`} 
              className="flex items-center mx-4 flex-shrink-0"
            >
              <Sparkles size={18} className="text-black mr-2 flex-shrink-0" fill="black" />
              <span className="text-sm font-bold text-black whitespace-nowrap">{service}</span>
            </div>
          ))}
          {/* Second set - duplicate for seamless infinite scroll */}
          {currentServices.map((service, index) => (
            <div 
              key={`4-${index}`} 
              className="flex items-center mx-4 flex-shrink-0"
            >
              <Sparkles size={18} className="text-black mr-2 flex-shrink-0" fill="black" />
              <span className="text-sm font-bold text-black whitespace-nowrap">{service}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarqueeServices;
